// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ifSNsn {
  width: 100%;
  min-height: 100%;
  background-color: var(--background-white);
  padding: var(--spacing-3);
  box-sizing: border-box;
}

.ir75WG {
  margin-bottom: var(--spacing-3);
  padding-bottom: var(--spacing-2);
  border-bottom: 2px solid var(--stroke-neutral-subtle);
}

.fDs2Pd {
  font-family: var(--font-family-base);
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-neutral-dark);
  margin: 0 0 var(--spacing-1) 0;
}

.yUdvMo {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.EbwVDw {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--spacing-3);
}

.sZGfq9 {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  background-color: var(--background-neutral-subtle, #fafafa);
  border-radius: var(--radius-m);
}

.FN4moX {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.s_8kFS {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--text-neutral-dark);
}

.ZLyjbt {
  padding: var(--spacing-0-5) var(--spacing-1);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  color: var(--text-neutral-dark);
  background-color: var(--background-white);
  cursor: pointer;
}

.ZLyjbt:hover {
  border-color: var(--stroke-neutral-stronger);
}

.ZLyjbt:focus {
  outline: none;
  border-color: var(--focus-default);
}

.nUHhwc {
  padding: var(--spacing-0-5) var(--spacing-1);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
  background-color: var(--background-white);
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all 0.2s;
}

.nUHhwc:hover {
  background-color: var(--background-neutral-subtle);
  border-color: var(--stroke-neutral-stronger);
}

.q_7VN8 {
  width: 100%;
  flex: 1;
  min-height: 400px;
  padding: var(--spacing-2);
  background-color: var(--background-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-m);
}

.vaRNRJ {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
}

.jIR7vS {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: var(--spacing-2);
  background-color: var(--background-neutral-subtle, #fafafa);
  border-radius: var(--radius-m);
}

.E8S8VO {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
  margin: 0;
}

.eRc4QW {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-stronger);
  margin: 0;
}

.zDDbtp {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: var(--spacing-2);
  width: 100%;
}

.H2enym {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
  padding: var(--spacing-2);
  background-color: var(--background-white);
  border: 1px solid var(--stroke-neutral-subtle);
  border-radius: var(--radius-m);
}

.uvzk78 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  color: var(--text-neutral-dark);
  margin: 0;
}

.VNkRnT {
  font-family: var(--font-family-base);
  font-size: var(--font-size-xs);
  color: var(--text-neutral-stronger);
  margin: 0;
  font-style: italic;
}

.VjTLX3 {
  padding: var(--spacing-2) 0;
  border-top: 1px solid var(--stroke-neutral-subtle);
}

.WrhsQ4 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  color: var(--text-neutral-stronger);
  margin: 0;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/Chart/examples/ChartExamplesPage.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;EAC/B,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,8CAA8C;EAC9C,8BAA8B;EAC9B,yCAAyC;EACzC,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;EACzC,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;EACzC,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,mCAAmC;EACnC,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".container {\n  width: 100%;\n  min-height: 100%;\n  background-color: var(--background-white);\n  padding: var(--spacing-3);\n  box-sizing: border-box;\n}\n\n.header {\n  margin-bottom: var(--spacing-3);\n  padding-bottom: var(--spacing-2);\n  border-bottom: 2px solid var(--stroke-neutral-subtle);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--text-neutral-dark);\n  margin: 0 0 var(--spacing-1) 0;\n}\n\n.subtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: var(--spacing-3);\n}\n\n.controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  background-color: var(--background-neutral-subtle, #fafafa);\n  border-radius: var(--radius-m);\n}\n\n.controlGroup {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.selectorLabel {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-neutral-dark);\n}\n\n.select {\n  padding: var(--spacing-0-5) var(--spacing-1);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  color: var(--text-neutral-dark);\n  background-color: var(--background-white);\n  cursor: pointer;\n}\n\n.select:hover {\n  border-color: var(--stroke-neutral-stronger);\n}\n\n.select:focus {\n  outline: none;\n  border-color: var(--focus-default);\n}\n\n.restoreButton {\n  padding: var(--spacing-0-5) var(--spacing-1);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n  background-color: var(--background-white);\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.restoreButton:hover {\n  background-color: var(--background-neutral-subtle);\n  border-color: var(--stroke-neutral-stronger);\n}\n\n.chartContainer {\n  width: 100%;\n  flex: 1;\n  min-height: 400px;\n  padding: var(--spacing-2);\n  background-color: var(--background-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-m);\n}\n\n.comparisonContainer {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n}\n\n.comparisonSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n  padding: var(--spacing-2);\n  background-color: var(--background-neutral-subtle, #fafafa);\n  border-radius: var(--radius-m);\n}\n\n.sectionTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.sectionDescription {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n}\n\n.chartsGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: var(--spacing-2);\n  width: 100%;\n}\n\n.chartCard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n  padding: var(--spacing-2);\n  background-color: var(--background-white);\n  border: 1px solid var(--stroke-neutral-subtle);\n  border-radius: var(--radius-m);\n}\n\n.chartTitle {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.chartNote {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-xs);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  font-style: italic;\n}\n\n.description {\n  padding: var(--spacing-2) 0;\n  border-top: 1px solid var(--stroke-neutral-subtle);\n}\n\n.descriptionText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  color: var(--text-neutral-stronger);\n  margin: 0;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ifSNsn`,
	"header": `ir75WG`,
	"title": `fDs2Pd`,
	"subtitle": `yUdvMo`,
	"content": `EbwVDw`,
	"controls": `sZGfq9`,
	"controlGroup": `FN4moX`,
	"selectorLabel": `s_8kFS`,
	"select": `ZLyjbt`,
	"restoreButton": `nUHhwc`,
	"chartContainer": `q_7VN8`,
	"comparisonContainer": `vaRNRJ`,
	"comparisonSection": `jIR7vS`,
	"sectionTitle": `E8S8VO`,
	"sectionDescription": `eRc4QW`,
	"chartsGrid": `zDDbtp`,
	"chartCard": `H2enym`,
	"chartTitle": `uvzk78`,
	"chartNote": `VNkRnT`,
	"description": `VjTLX3`,
	"descriptionText": `WrhsQ4`
};
module.exports = ___CSS_LOADER_EXPORT___;
